(() => {
  const state = document.querySelector('[data-mt-account-state]');
  if (!state) return;
  const signedIn = state.dataset.signedIn === 'true';
  const storageKey = 'martillo-purchase-selection';
  let purchaseInteraction = false;
  const isProductForm = form => form instanceof HTMLFormElement && /\/cart\/add(?:\.js)?$/.test(new URL(form.action, location.origin).pathname);
  const signIn = (form, button) => {
    if (!form.reportValidity()) return;
    const variant = form.querySelector('[name="id"]');
    if (!variant?.value || variant.disabled) return;
    const quantity = form.querySelector('[name="quantity"]')?.value || '1';
    const path = form.closest('product-form-component')?.dataset.productUrl || location.pathname;
    const returnUrl = new URL(path, location.origin);
    if (returnUrl.origin !== location.origin) return;
    returnUrl.searchParams.set('variant', variant.value);
    returnUrl.hash = 'purchase';
    try {
      const resume = crypto.randomUUID();
      const intent = button?.matches('[data-mt-buy-now]') ? 'buy' : 'add';
      sessionStorage.setItem(storageKey, JSON.stringify({ path: returnUrl.pathname, variant: variant.value, quantity, intent, resume, time: Date.now() }));
      returnUrl.searchParams.set('mt_resume', resume);
    } catch {}
    const loginUrl = new URL(state.dataset.loginUrl, location.origin);
    loginUrl.searchParams.set('return_to', returnUrl.pathname + returnUrl.search + returnUrl.hash);
    location.assign(loginUrl.href);
  };
  window.addEventListener('click', event => {
    if (signedIn && event.isTrusted && event.target instanceof Element && event.target.closest('form[action*="/cart/add"]')) purchaseInteraction = true;
    const button = event.target instanceof Element ? event.target.closest('[data-mt-sign-in]') : null;
    if (!button || button.disabled || signedIn) return;
    const form = button.closest('form');
    if (!isProductForm(form)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    signIn(form, button);
  }, true);
  window.addEventListener('submit', event => {
    const form = event.target;
    if (!isProductForm(form)) return;
    if (!signedIn) {
      event.preventDefault();
      event.stopImmediatePropagation();
      signIn(form, event.submitter);
      return;
    }
    if (event.submitter?.matches('[data-mt-buy-now]')) {
      const variant = form.querySelector('[name="id"]');
      if (!variant?.value || variant.disabled) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      let redirect = form.querySelector('input[name="return_to"]');
      if (!redirect) {
        redirect = document.createElement('input');
        redirect.type = 'hidden';
        redirect.name = 'return_to';
        form.append(redirect);
      }
      redirect.value = '/checkout';
      event.stopImmediatePropagation();
    } else {
      form.querySelector('input[name="return_to"]')?.remove();
    }
  }, true);
  const restoreSelection = async () => {
    let selection;
    try { selection = JSON.parse(sessionStorage.getItem(storageKey) || 'null'); } catch {}
    const age = Date.now() - Number(selection?.time);
    if (!selection || selection.path !== location.pathname || !Number.isFinite(age) || age < 0 || age > 1800000) return;
    const forms = [...document.querySelectorAll('form[action*="/cart/add"]')].filter(form => isProductForm(form) && form.querySelector('[name="id"]')?.value === selection.variant);
    forms.forEach(form => {
      const input = form.querySelector('[name="quantity"]');
      if (!input) return;
      const min = Number(input.min) || 1;
      const max = Number(input.max) || Number.MAX_SAFE_INTEGER;
      input.value = String(Math.min(max, Math.max(min, parseInt(selection.quantity, 10) || min)));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    if (!signedIn) return;
    const url = new URL(location.href);
    const shouldResume = selection.resume && url.searchParams.get('mt_resume') === selection.resume && ['add', 'buy'].includes(selection.intent);
    try { sessionStorage.removeItem(storageKey); } catch { return; }
    if (!shouldResume) return;
    url.searchParams.delete('mt_resume');
    history.replaceState(history.state, '', url.pathname + url.search + url.hash);
    const form = forms.find(candidate => candidate.getClientRects().length);
    if (!form) return;
    if (form.closest('product-form-component')) {
      await Promise.race([customElements.whenDefined('product-form-component'), new Promise(resolve => setTimeout(resolve, 5000))]);
      if (!customElements.get('product-form-component')) return;
    }
    const button = form.querySelector(selection.intent === 'buy' ? '[data-mt-buy-now]' : '[name="add"]');
    const variant = form.querySelector('[name="id"]');
    if (purchaseInteraction || !form.isConnected || !button || button.disabled || button.type !== 'submit' || variant?.value !== selection.variant || variant.disabled || !form.reportValidity()) return;
    form.requestSubmit(button);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restoreSelection, { once: true });
  else restoreSelection();
})();
